export const DATA_SCALE_HANDLE = 'data-scale-handle';
export const TOXICS_HIGH_RISK_SCORE = 3;

export const TOXICS_RISK_ASSESSMENTS = {
    RISK_ASSESSMENT_HIGH: 'risk_assessment_high',
    RISK_ASSESSMENT_VERY_HIGH: 'risk_assessment_very_high'
};

export const TOXICS_RISKS = [
    'report_derailment_score_low_score',
    'report_derailment_score_average_score',
    'report_derailment_score_high_score',
    'report_derailment_score_very_high_score'
];
